import { getScreenSettings, mergeCompositeSetting } from "@client/lib/settings";
import { screenSelector } from "@client/selectors";
import { type StyleSheetType } from "@client/types/StyleSheet";
import React from "react";
import { useSelector } from "react-redux";
import { styleSheetDataItemLocalSettingsSelector, styleSheetDataItemSettingsSelector } from "../selectors";
import Color from "./Color";
import Link from "./Link";
import Text from "./Text";

type Props = {
  rootSelector: string;
  type: StyleSheetType;
  id: string;
};
export default (props: Props) => {
  const screen = useSelector(screenSelector);
  const settings = useSelector((state) => styleSheetDataItemSettingsSelector(state, props.id));
  const localSettings = useSelector((state) => styleSheetDataItemLocalSettingsSelector(state, props.id));

  const setting = React.useMemo(
    () =>
      mergeCompositeSetting(
        (screen) => getScreenSettings(settings, screen),
        localSettings ? (screen) => getScreenSettings(localSettings, screen) : null,
        screen
      )!,
    [settings, localSettings, screen]
  );

  switch (props.type) {
    case "color":
      return <Color id={props.id} setting={setting} />;
    case "link":
      return <Link id={props.id} screen={screen} setting={setting} />;
    default:
      return <Text id={props.id} setting={setting} type={props.type} />;
  }
};
